<div class="card info-card" [ngClass]="{'info-card__no-border':!hasBorder}" >
    <span dssIcon name="{{icon}}"></span>
    <div class="info-card__body">
        <span *ngIf="title" dssTypography type="caption">{{title}}</span>
        <div *ngIf="description" dssTypography type="caption" [innerHtml]="description"></div>
        <a dssTypography type="caption" *ngIf="linkText" class="link-button" href="{{url}}" target="_blank" id="urlLink">{{linkText}}</a>
    </div>
</div>
